import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import InfoIcon from "@mui/icons-material/Info";

export default function CustomMessage({message}) {
  return (
<Grid container>
      <Grid item xs={12} textAlign="center">
                  <Box
                    sx={{
                      background: "#BA15150F",
                      padding: "10px",
                      borderRadius: "8px",
                    }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    gap={1}
                  >
                    <InfoIcon style={{ color: "#BA1515" }} />
                    <Typography
                      fontSize="12px"
                      color="#BA1515"
                      sx={{
                        fontWeight: 400,
                        fontFamily: "Inter",
                        lineHeight: "100%",
                        fontStyle: "normal",
                        letterSpacing: "0%",
                      }}
                    >
                   {message}
                    </Typography>
                  </Box>
                </Grid>
</Grid>
  )
}
